<template>
  <VAvatar :placeholder :seed="user.id" :size />
</template>

<script setup lang="ts">
import { type User } from '~/types.ts'

interface Props {
  user: User
  size?: number
}

const { user, size = 26 } = defineProps<Props>()

const placeholder = computed(() => (user ? `${user.first_name.charAt(0)}${user.last_name.split(' ').pop()?.charAt(0)}` : ''))
</script>
